<script>

import WorkflowSetting from '@/components/workflow/WorkflowSetting.vue'

export default {
  name: 'OaFlowSetting',
  components: {
    WorkflowSetting
  }
}
</script>

<template>
  <WorkflowSetting />
</template>

<style scoped>

</style>
